import { useSendCommandAsync } from '@/_core/cqrs/use';
import { RealTimeAction } from '@/_core/fluxstore/types';
import { CreateTrashCardCommand } from '../../api/commands/factory/createTrashCard';
import { StorymapState } from '../types';
import { deleteCard, getCardById, getNearestCardAfterDelete, isSubtask } from '../use';
import { useStorymapStore } from '../useModule';
import { SetActiveCardIdByClick } from './cardSelection/setActiveCardIdByClick';
import { FlashJustDragged } from './moveCard/flashJustDragged';

const { registerReducer, registerMiddleware, dispatch } = useStorymapStore();

export class DeleteCard extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'DeleteCard';
    /** Local completion observation; optimistic reduction and existing callers retain their contract. */
    public get _completion(): Promise<boolean> { return completions.get(this) ?? Promise.resolve(false); }

    public constructor(public cardId: string) {
        super(DeleteCard.ACTION_TYPE);
    }
}

const completions = new WeakMap<DeleteCard, Promise<boolean>>();

const middleware = async (state: StorymapState, action: DeleteCard): Promise<boolean> => {
    completions.set(action, useSendCommandAsync(action, {
        createCommand: async () => await CreateTrashCardCommand(action),
        acceptNullResult: true,
    }).catch(() => false));

    return true;
};

const reducer = (state: StorymapState, action: DeleteCard): void => {
    const card = getCardById(action.cardId);
    const neighbor = getNearestCardAfterDelete(action.cardId);

    if (neighbor != null) {
        dispatch(new SetActiveCardIdByClick(neighbor.id));
    } else if (card && isSubtask(card)) {
        const hasMoreCardsInRelease = state.subtasks.some(x => x.id !== card.id && x.releaseId === card.releaseId);

        if (!hasMoreCardsInRelease) {
            dispatch(new FlashJustDragged());
        }
    }

    deleteCard(action.cardId);
};

//@ts-ignore
registerMiddleware(DeleteCard.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(DeleteCard.ACTION_TYPE, reducer);
